export default {
  name: 'customLngDetector',

  lookup() {
    const hasNavigator = typeof navigator !== 'undefined';
    const currentLng = localStorage.getItem('i18nextLng');
    const availableLng = localStorage.getItem('i18nAvailableLng');
    const lngList = JSON.parse(availableLng);
    const lngDetected = hasNavigator && navigator.language;
    const lngParsed = hasNavigator && navigator.language.split('-')[0];
    const l = lngList?.findIndex(e => e === lngDetected);
    const ll = lngList?.findIndex(e => e === lngParsed);

    if (currentLng) {
      return currentLng;
    }

    // Always return the language that matches most.
    if (l && l !== -1) {
      return lngList[l];
    }

    if (ll && ll !== -1) {
      return lngList[ll];
    }

    // If the detected language doesn't match any available languages return the English as default.
    return 'en';
  },
};
